import { createFileRoute } from "@tanstack/react-router";
import { OwnResident } from "@/components/app/portal/pages/own-resident";
import { ResidentNotesPage } from "@/components/app/portal/pages/resident-notes-page";

export const Route = createFileRoute("/resident-portal/notes")({
  head: () => ({ meta: [{ title: "Messages | People AI" }] }),
  component: ResidentNotes,
});

function ResidentNotes() {
  return (
    <OwnResident>
      {(own) => <ResidentNotesPage kind="resident" residentId={own.residentId} />}
    </OwnResident>
  );
}
